import { EClickPosition } from 'shared/constant';
import { EPageModule } from 'shared/constant/page-module';
import { EArticleClass } from 'shared/models/article';

export const sendClickEvent = (props: { clickPosition: EClickPosition; clickId?: string }): void => {
  const { clickPosition, clickId } = props;
  window.Tea('wap_click', {
    current_position: clickPosition,
    page_click_id: clickId || null,
  });
};

export const sendCTAShowEvent = (props: { pageModule: EPageModule; currentPosition: EClickPosition }): void => {
  const { pageModule, currentPosition } = props;

  window.Tea('wap_cta_show', {
    current_page_module: pageModule,
    current_position: currentPosition,
  });
};

export const sendRelatedPostShowEvent = (props: {
  pageModule: EPageModule;
  clickPosition: EClickPosition;
  groupId: string;
  mediaId: string;
  articleClass: EArticleClass;
  rank: number;
}): void => {
  const { pageModule, clickPosition, groupId, mediaId, articleClass, rank } = props;
  window.Tea('wap_related_post_show', {
    current_page_module: pageModule,
    current_position: clickPosition,
    group_id: groupId,
    media_id: mediaId,
    article_class: articleClass.toLowerCase(),
    rank,
  });
};
